import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import FocusDragArea from '../../common/components/FocusDragArea';
import { mediaPickerAvailable, openMediaPicker } from '../mediaPicker';
import { formatBytes, clampZoom } from '../../common/util';
/**
 * Full cover management: upload a new image, reuse one from the media manager,
 * drag the focal point (pos-crop) with live preview, save the position without
 * re-uploading, or detach the cover.
 */
export default class CoverEditorModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "focusX", 50);
    _defineProperty(this, "focusY", 50);
    _defineProperty(this, "zoom", 1);
    _defineProperty(this, "dirty", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.syncFromUser();
  }
  className() {
    return 'ProfileCover-Modal Modal--small';
  }
  title() {
    return app.translator.trans('ziven-profile-cover.forum.editor.title');
  }
  get user() {
    return this.attrs.user;
  }
  syncFromUser() {
    var _this$user$coverFocus, _this$user$coverFocus2, _this$user$coverZoom;
    this.focusX = Number((_this$user$coverFocus = this.user.coverFocusX()) != null ? _this$user$coverFocus : 50);
    this.focusY = Number((_this$user$coverFocus2 = this.user.coverFocusY()) != null ? _this$user$coverFocus2 : 50);
    this.zoom = clampZoom(Number((_this$user$coverZoom = this.user.coverZoom()) != null ? _this$user$coverZoom : 1));
    this.dirty = false;
  }
  content() {
    const coverUrl = this.user.coverUrl();
    // The preview area is ~560px wide at most — the fof/upload thumbnail
    // (same aspect ratio, a fraction of the size) is plenty and loads much
    // faster on image-heavy pages. Falls back to the full image when the
    // forum has thumbnails disabled.
    const previewUrl = this.user.coverThumbUrl() || coverUrl;
    const maxSize = Number(app.forum.attribute('ziven-profile-cover.max_size') || 2048);
    const height = Math.max(120, Math.min(Number(app.forum.attribute('ziven-profile-cover.cover_height') || 220), 260));
    return m("div", {
      className: "Modal-body ProfileCover-Editor"
    }, coverUrl ? [m(FocusDragArea, {
      url: previewUrl,
      focusX: this.focusX,
      focusY: this.focusY,
      zoom: this.zoom,
      height: height,
      onchange: (x, y) => {
        this.focusX = x;
        this.focusY = y;
        this.dirty = true;
      },
      onzoom: this.setZoom.bind(this)
    }), this.zoomControl()] : m("div", {
      className: "ProfileCover-Editor-empty",
      style: {
        height: "".concat(height, "px")
      }
    }, this.loading ? m(LoadingIndicator, null) : m("p", null, app.translator.trans('ziven-profile-cover.forum.editor.empty_hint'))), m("p", {
      className: "ProfileCover-Editor-sizeHint helpText"
    }, app.translator.trans('ziven-profile-cover.forum.editor.size_hint', {
      max: formatBytes(maxSize * 1024)
    })), m("div", {
      className: "ProfileCover-Editor-actions"
    }, m(Button, {
      className: "Button",
      icon: "fas fa-upload",
      loading: this.loading,
      onclick: this.openFilePicker.bind(this)
    }, app.translator.trans('ziven-profile-cover.forum.editor.upload_button')), mediaPickerAvailable(this.user) && m(Button, {
      className: "Button",
      icon: "fas fa-photo-video",
      disabled: this.loading,
      onclick: this.openMediaManager.bind(this)
    }, app.translator.trans('ziven-profile-cover.forum.editor.media_button')), !!coverUrl && m(Button, {
      className: "Button Button--danger",
      icon: "fas fa-times",
      disabled: this.loading,
      onclick: this.remove.bind(this)
    }, app.translator.trans('ziven-profile-cover.forum.editor.remove_button'))), !!coverUrl && m("div", {
      className: "ProfileCover-Editor-save"
    }, m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-check",
      loading: this.loading,
      disabled: !this.dirty,
      onclick: this.saveFocus.bind(this)
    }, app.translator.trans('ziven-profile-cover.forum.editor.save_position_button'))));
  }
  setZoom(zoom) {
    this.zoom = clampZoom(zoom);
    this.dirty = true;
  }
  zoomControl() {
    return m("div", {
      className: "ProfileCover-Editor-zoom"
    }, m("label", {
      htmlFor: "ProfileCover-cover-zoom"
    }, app.translator.trans('ziven-profile-cover.forum.editor.zoom_label')), m("input", {
      id: "ProfileCover-cover-zoom",
      type: "range",
      min: "0.5",
      max: "3",
      step: "0.05",
      list: "ProfileCover-zoom-ticks",
      value: this.zoom,
      disabled: this.loading,
      oninput: e => this.setZoom(parseFloat(e.target.value))
    }), m("datalist", {
      id: "ProfileCover-zoom-ticks"
    }, m("option", {
      value: "1"
    })), m("button", {
      type: "button",
      className: "Button Button--link ProfileCover-Editor-zoomValue",
      title: app.translator.trans('ziven-profile-cover.forum.editor.zoom_reset'),
      disabled: this.loading,
      onclick: () => this.setZoom(1)
    }, this.zoom.toFixed(2), "\xD7"));
  }
  openFilePicker() {
    if (this.loading) return;
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/jpeg,image/png,image/webp,image/gif';
    input.addEventListener('change', () => {
      var _input$files;
      const file = (_input$files = input.files) == null ? void 0 : _input$files[0];
      if (file) this.upload(file);
    });
    input.click();
  }
  upload(file) {
    const body = new FormData();
    body.append('cover', file);
    // A fresh image starts centered, without zoom.
    body.append('focusX', '50');
    body.append('focusY', '50');
    body.append('zoom', '1');
    this.request({
      method: 'POST',
      body,
      serialize: raw => raw
    });
  }
  openMediaManager() {
    openMediaPicker(this.user, fileId => {
      this.request({
        method: 'POST',
        body: {
          fileId,
          focusX: 50,
          focusY: 50,
          zoom: 1
        }
      });
    });
  }
  saveFocus() {
    if (this.loading || !this.dirty) return;
    this.request({
      method: 'PATCH',
      body: {
        focusX: this.focusX,
        focusY: this.focusY,
        zoom: this.zoom
      }
    });
  }
  remove() {
    if (this.loading) return;
    if (!confirm(app.translator.trans('ziven-profile-cover.forum.editor.remove_confirm'))) return;
    this.request({
      method: 'DELETE'
    });
  }
  request(options) {
    this.loading = true;
    this.alertAttrs = null;
    m.redraw();
    app.request(_objectSpread({
      url: "".concat(app.forum.attribute('apiUrl'), "/users/").concat(this.user.id(), "/ziven-profile-cover"),
      method: options.method,
      body: options.body
    }, options.serialize ? {
      serialize: options.serialize
    } : {})).then(response => {
      if (response) app.store.pushPayload(response);
      this.loading = false;
      this.syncFromUser();
      this.alertAttrs = {
        type: 'success',
        content: app.translator.trans('ziven-profile-cover.forum.editor.saved')
      };
      m.redraw();
    }).catch(error => {
      var _error$response;
      this.loading = false;
      this.alertAttrs = {
        type: 'error',
        content: (error == null || (_error$response = error.response) == null || (_error$response = _error$response.errors) == null || (_error$response = _error$response[0]) == null ? void 0 : _error$response.detail) || app.translator.trans('ziven-profile-cover.forum.editor.generic_error')
      };
      m.redraw();
    });
  }
}
flarum.reg.add('ziiven-profile-cover', 'forum/components/CoverEditorModal', CoverEditorModal);